import IconCopy from '../../../../../components/icons/icon-copy/icon-copy';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';

interface ICopyButtonProps {
    value: string | number | undefined | null;
}

const CopyButton: React.FC<ICopyButtonProps> = ({ value }) => {
    const toStr = (v: any | undefined) => !!v?.toString ? v.toString() : '';
    
    const handleClick = () => {
        navigator.clipboard.writeText(toStr(value));
    };

    return (
        <ButtonIcon 
            Component={IconCopy}
            onClick={handleClick}
        />  
    );
};

export default CopyButton; 